import { config } from "../config";

// Endpoint base
const protocol = config.coreApi.protocol;
const host = config.coreApi.host;
const urlPrefixMisc = `${protocol}://${host}/clinics/v1/misc`;

export type TLogUIErrorRequest = {
  message: string;
  page_url?: string | null;
  user_email?: string | null;
  stack_trace?: string | null;
  context?: Record<string, any> | null;
  clinic_id?: string | null;
  clinic_name?: string | null;
};

/**
 * Sends a UI error payload to the backend `/misc/log-ui-error` endpoint.
 * Requires `X-UI-Error-Token` to be set (e.g., via env `EXPO_PUBLIC_UI_ERROR_TOKEN`).
 */
export const logUIError = async (
  payload: TLogUIErrorRequest,
  tokenOverride?: string,
): Promise<void> => {
  const token = tokenOverride || process.env.EXPO_PUBLIC_UI_ERROR_TOKEN;

  if (!token) {
    console.warn("logUIError: missing UI error token; skipping send");
    return;
  }

  const response = await fetch(`${urlPrefixMisc}/log-ui-error`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-UI-Error-Token": token,
    },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    const errorText = await response.text().catch(() => "");
    throw new Error(
      `Failed to log UI error: ${response.status} ${response.statusText} ${errorText}`,
    );
  }
};
